import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from '../../core/services/http-data.service';
import { Observable, of } from 'rxjs';
import { LAST_MONTH_DATE_FILTER, LAST_MONTH_TIME_PERIOD } from '@widgets/assets/constants';

@Injectable()
export class DashboardService extends HttpDataService {
  constructor(protected injector: Injector) {
    super(injector, '/dashboard');
  }

  /**
   * Get the data of the dashboard widgets
   * @param clientIds
   * @param dateFilter
   * @param timePeriod
   */
  public getClientsDashboardData(clientIds: string[], dateFilter?: string, timePeriod?: string): Observable<any> {
    const queryParams = new URLSearchParams();
    queryParams.append('clientId', clientIds.join(','));
    queryParams.append('lang', localStorage.getItem('backofficelanguage'));
    queryParams.append('from', dateFilter);
    queryParams.append('timePeriod', timePeriod);

    return this.fetchRequest(`${this.baseUrl}/clients/?${queryParams.toString()}`, null);
  }

  /**
   * Request data for a client and widget
   * @param clientId client id
   * @param widgetName widget name
   * @param params query params
   */
  public getClientWidget(clientId: string, widgetName: string, params?: any): Observable<any> {
    return this.fetchRequest(`${this.baseUrl}/clients/${clientId}/widgets/${widgetName}`, params, null);
  }

  /**
   * Request widget data
   * @param clientIds client ids array
   * @param widgetName widget name
   * @param params query params
   */
  public getWidgetData(clientIds: string[], widgetName: string, params?: any): Observable<any> {
    const queryParams = {
      ...params,
      clientId: clientIds.join(',')
    };
    return this.fetchRequest(`${this.baseUrl}/clients/widgets/${widgetName}`, queryParams, null);
  }

  /**
   * Get the widgets for the dashboard
   * @private
   * @param clientIds
   */
  public getDashboardWidgets$(clientIds: string[]): Observable<any> {
    if (clientIds?.length) {
      return this.getClientsDashboardData(clientIds, LAST_MONTH_DATE_FILTER, LAST_MONTH_TIME_PERIOD);
    }
    return of(null);
  }
}
